import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UpdateUserForm from './UpdateUser/UpdateUserForm';
import CreateUserForm from './CreateUser/CreateUserForm';
// import AdminPanelStyles from './styles';
import './AdminPanel.css';

const AdminPanel = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [tool, setTool] = React.useState('create');

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    if (newAlignment !== null) {
      setTool(newAlignment);
    }
  };

  return (
    <Box
      className="admin-panel"
      color={theme.brandcolor.primaryDark}
      sx={{ bgcolor: theme.brandcolor.primaryLight }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '1em',
        }}
      >
        <Button
          variant="text"
          size="large"
          sx={{ color: 'black' }}
          onClick={() => {
            navigate('/home');
          }}
          startIcon={<ArrowBackIcon />}
        >
          Home
        </Button>
        <ToggleButtonGroup
          color="primary"
          value={tool}
          exclusive
          onChange={handleChange}
          size="large"
          sx={{ flexGrow: 1, justifyContent: 'center', display: 'flex' }}
        >
          <ToggleButton value="create">Create User</ToggleButton>
          <ToggleButton value="update">Update User</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {tool === 'create' && <CreateUserForm />}
      {tool === 'update' && <UpdateUserForm />}
    </Box>
  );
};

export default AdminPanel;
